import { GVContext, useGVInit } from './GV';
import MainForm from './MainForm';
import { AppContext } from '../libs/app-core/AppContext';
import { useAppContext } from '../libs/app-core/AppContext';
import ErrorBoundary from './ErrorBoundary';


type Props = {}

const Program2 = (props: Props) => {

  var app_context_methods = useAppContext();
  var GV = useGVInit();

  return (
    <ErrorBoundary>
      <AppContext.Provider value={app_context_methods}>
        <GVContext.Provider value={GV}>

          <MainForm />

        </GVContext.Provider>
      </AppContext.Provider>
    </ErrorBoundary>
  )
}

export default Program2